var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.artists && _setup.artists.length)?_c('div',[_c('BaseSection',{attrs:{"title":"Trending Artists"}},[_c(_setup.ArtistBlock,{attrs:{"artists":_setup.artists}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }